import { Link } from 'react-router-dom';
import { ShoppingCart } from '@/components/ui/icons';
import { cn } from '@/lib/utils';

export type CartButtonProps = {
  to?: string;
  count?: number;
  label: string;
  showLabel?: boolean;
  className?: string;
};

export function CartButton({
  to = '/cart',
  count = 0,
  label,
  showLabel = true,
  className,
}: CartButtonProps): JSX.Element {
  return (
    <Link
      to={to}
      aria-label={count > 0 ? `${label} (${count})` : label}
      className={cn(
        'relative inline-flex shrink-0 items-center gap-2 rounded-md px-2 py-2 font-sans text-sm font-medium text-brand-100/90 transition-colors hover:bg-brand-900 hover:text-brand-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400',
        className,
      )}
    >
      <ShoppingCart className="h-5 w-5 shrink-0" aria-hidden />
      {showLabel ? <span className="hidden lg:inline">{label}</span> : null}
      {count > 0 ? (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand-400 px-1 text-2xs font-bold leading-none text-brand-950 lg:static lg:ml-0">
          {count > 99 ? '99+' : count}
        </span>
      ) : null}
    </Link>
  );
}
